import React from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { FundraiserInfo } from "api";
import { openDonateDialog } from "state/donatedialog/actions";
import { useParent, useDispatcher } from "ui/hook";
import { Button } from "ui/control";
import * as Browser from "ui/browser";
import { Icon, msVolunteerActivism } from "ui/material-symbols";

interface Props {
    name: string | null;
    fullName: string | null;
    fundraisers: FundraiserInfo[] | null;
    styles?: "large" | "small" | "icon";
    className?: string;
}

export function DonateButton({name, fullName, fundraisers, styles = "large", className}: Props) {
    const dispatch = useDispatcher();
    const {t} = useTranslation();

    const {hide: hidePopover} = useParent();

    if (name == null || fundraisers == null || fundraisers.length === 0) {
        return null;
    }

    if (Browser.isAndroidGooglePlay()) {
        return null;
    }

    const onClick = () => {
        hidePopover();
        dispatch(openDonateDialog(name, fullName, fundraisers));
    };

    return (
        <Button variant="outline-success"
                size={styles === "small" ? "sm" : undefined}
                title={styles === "icon" ? t("donate") : undefined}
                className={cx(className, {"border-0": styles === "icon"})}
                onClick={onClick}>
            <Icon icon={msVolunteerActivism} size="1.5em"/>
            {styles !== "icon" ? " " + t("donate") : ""}
        </Button>
    );
}
